import React, { useEffect, useState } from "react";
import API from "../services/api";
import Sidebar from "../components/Sidebar";
import { toast } from "react-toastify";

function Photos() {
  const [dashboard, setDashboard] = useState(null);
  const [photos, setPhotos] = useState([]);
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [note, setNote] = useState("");
  const [filterDay, setFilterDay] = useState("");
  const [filterDate, setFilterDate] = useState("");

  useEffect(() => {
    fetchDashboard();
    fetchPhotos();
  }, []);

  const fetchDashboard = async () => {
    try {
      const res = await API.get("/dashboard/summary");
      setDashboard(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchPhotos = async () => {
    try {
      const res = await API.get("/photos/list");
      setPhotos(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const uploadPhoto = async () => {
    if (!selectedPhoto) {
      toast.error("Please select a photo");
      return;
    }

    const formData = new FormData();
    formData.append("photo", selectedPhoto);
    formData.append("remarks", note);

    try {
      await API.post("/photos/upload", formData);

      toast.success("Photo uploaded successfully");

      setSelectedPhoto(null);
      setNote("");
      fetchPhotos();
    } catch {
      toast.error("Upload failed");
    }
  };

  const deletePhoto = async (id) => {
    try {
      await API.delete(`/photos/${id}`);
      toast.success("Photo deleted");
      fetchPhotos();
    } catch {
      toast.error("Delete failed");
    }
  };

  const progress =
    dashboard?.total_days > 0
      ? Math.round(
          (dashboard.current_day / dashboard.total_days) * 100
        )
      : 0;

  const filteredPhotos = photos.filter((photo) => {
    let match = true;

    if (filterDate) {
      match =
        match &&
        photo.uploaded_at?.split("T")[0] === filterDate;
    }

    return match;
  });

  return (
    <div className="dashboard-layout">
      <Sidebar />

      <div className="main-content">
        <div className="container-fluid">

          {/* Photo Reminder */}
          <div className="card dashboard-card photo-card mb-4">
            <div className="d-flex justify-content-between align-items-center flex-wrap">
              <div>
                <h5>📷 Daily Photo Reminder</h5>
                <p>
                  Capture a quick photo of your vermibed
                  to track daily progress.
                </p>
              </div>

              <button className="btn btn-success">
                Take Today's Photo
              </button>
            </div>
          </div>

          {/* Summary */}
          <div className="row g-4 mb-4">
            <div className="col-md-4">
              <div className="card dashboard-card text-center">
                <h6>Current Day</h6>
                <h2>
                  {dashboard?.current_day || 0}/
                  {dashboard?.total_days || 60}
                </h2>
                <small>
                  {(dashboard?.total_days || 60) -
                    (dashboard?.current_day || 0)} days remaining
                </small>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card dashboard-card text-center">
                <h6>Current Phase</h6>

                <span className="badge bg-primary p-2">
                  {dashboard?.current_phase || "Not Started"}
                </span>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card dashboard-card text-center">
                <h6>Progress</h6>

                <div className="progress mb-2">
                  <div
                    className="progress-bar bg-success"
                    style={{ width: `${progress}%` }}
                  ></div>
                </div>

                <h4>{progress}%</h4>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="row g-4">

            {/* Upload Panel */}
            <div className="col-md-5">
              <div className="card dashboard-card h-100">
                <h3>📸 Capture Photo — Day {dashboard?.current_day || 1}</h3>

                <div className="mb-3">
                  <label className="form-label">
                    Choose File
                  </label>

                  <input
                    type="file"
                    className="form-control"
                    onChange={(e) =>
                      setSelectedPhoto(e.target.files[0])
                    }
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Take Photo
                  </label>

                  <input
                    type="file"
                    accept="image/*"
                    capture="environment"
                    className="form-control"
                    onChange={(e) =>
                      setSelectedPhoto(e.target.files[0])
                    }
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Note (Optional)
                  </label>

                  <textarea
                    className="form-control"
                    rows="5"
                    placeholder="Write your observations..."
                    value={note}
                    onChange={(e) =>
                      setNote(e.target.value)
                    }
                  />
                </div>

                <button
                  className="btn btn-success"
                  onClick={uploadPhoto}
                >
                  Save Photo
                </button>
              </div>
            </div>

            {/* Gallery */}
            <div className="col-md-7">
              <div className="card dashboard-card h-100">
                <h3>🖼 Progress Gallery</h3>

                <div className="d-flex gap-2 flex-wrap mb-4">
                  <select
                    className="form-select w-auto"
                    value={filterDay}
                    onChange={(e) =>
                      setFilterDay(e.target.value)
                    }
                  >
                    <option value="">Day</option>
                    <option value="1">Day 1</option>
                    <option value="2">Day 2</option>
                  </select>

                  <input
                    type="date"
                    className="form-control w-auto"
                    value={filterDate}
                    onChange={(e) =>
                      setFilterDate(e.target.value)
                    }
                  />

                  <button
                    className="btn btn-danger"
                    onClick={() => {
                      setFilterDay("");
                      setFilterDate("");
                    }}
                  >
                    Clear
                  </button>
                </div>

                {filteredPhotos.length > 0 ? (
                  <div className="row">
                    {filteredPhotos.map((photo) => (
                      <div
                        className="col-md-6 mb-4"
                        key={photo.id}
                      >
                        <div className="gallery-card">
                          <img
                            src={`http://localhost:5000/uploads/${photo.photo_path}`}
                            alt=""
                            className="img-fluid rounded"
                          />

                          <p className="mt-2">
                            {photo.remarks}
                          </p>

                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() =>
                              deletePhoto(photo.id)
                            }
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="empty-gallery">
                    No photos yet. Start capturing your progress.
                  </div>
                )}
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>
  );
}

export default Photos;